import active_event from './events/ga2025'

export default active_event
